(() => {
  document.querySelectorAll('cart-items').forEach((cart) => {
    let scheduled = false;
    const syncTotal = () => {
      scheduled = false;
      const source = cart.querySelector('[data-cart-total] .cart-total-grandtotal .cart-total-value');
      const target = cart.querySelector('[data-cart-overview-total]');
      if (!source || !target) return;
      const value = source.textContent.trim();
      if (value && target.textContent !== value) target.textContent = value;
    };
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(syncTotal);
    });
    observer.observe(cart, { childList: true, subtree: true, characterData: true });
    syncTotal();
  });
})();
(() => {
  const button = document.querySelector('cart-items [data-cart-chat]');
  if (!button) return;
  const api = window.Tawk_API = window.Tawk_API || {};
  const mobile = window.matchMedia('(max-width: 767px)');
  let hiddenByCart = false;
  const available = () => ['hideWidget', 'showWidget', 'maximize', 'isChatMaximized'].every(name => typeof api[name] === 'function');
  const syncChat = () => {
    if (!available()) return;
    button.hidden = !mobile.matches;
    if (mobile.matches && !api.isChatMaximized()) {
      api.hideWidget();
      hiddenByCart = true;
    } else if (!mobile.matches && hiddenByCart) {
      api.showWidget();
      hiddenByCart = false;
    }
  };
  ['onLoad', 'onChatMinimized'].forEach(name => {
    const previous = api[name];
    api[name] = function (...args) {
      try {
        if (typeof previous === 'function') previous.apply(this, args);
      } finally {
        syncChat();
      }
    };
  });
  button.addEventListener('click', () => {
    if (!available()) return;
    api.showWidget();
    hiddenByCart = false;
    api.maximize();
  });
  mobile.addEventListener('change', syncChat);
  syncChat();
})();
